import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import TopNav from "../components/TopNav";
import BottomNav from "../components/BottomNav";
import Footer from "../components/footer/Footer";
import { ToastContainer, toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { MdCall, MdEmail } from "react-icons/md";
import { BsTelephone, BsSend } from "react-icons/bs";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";

import B1 from "../makkaanpages/images/Artboard 1.jpg";
import B2 from "../makkaanpages/images/Artboard 1-1.jpg";

import karat1 from "../makkaanpages/images/9K Nathiagali short payment plan.png";
import karat2 from "../makkaanpages/images/9k nathiagali floorplan.webp";
import developerlogo from "../makkaanpages/images/9ksuiteslogo.png";
import makkaanLogo from "../makkaanpages/images/makkaanlogo.png";

import paymentplan from "../makkaanpages/pdf/9knathiagali-floorplan.pdf";
import floorplan from "../makkaanpages/pdf/9knathiagali-floorplan.pdf";

import floor from "../makkaanpages/images/avenue18floor.png";
import payment from "../makkaanpages/images/avenue18payment.png";

import Slider from "react-slick";

import "./CustomArrow.css";
import "../App.css";
import api_url from "../ApiUrl";
import axios from "axios";

import { SampleNextArrow, SamplePrevArrow } from "./CustomArrow";
import lightgreen from "../makkaanpages/images/lightgreen.jpg";

import ReactPlayer from "react-player";

function Nineknathia() {
  const formRef = useRef();
  const paymentRef = useRef();

  const [isSticky, setIsSticky] = useState(false);
  const [isBottom, setIsBottom] = useState(false);
  const [paymentTop, setPaymentTop] = useState(0);
  const [formHeight, setFormHeight] = useState(0);
  const [modalImages, setModalImages] = useState([]);

  const [isFixed, setIsFixed] = useState(false);

  const [stickyLeft, setStickyLeft] = useState(0);

  const [modalImage, setModalImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpandedd, setIsExpandedd] = useState(false);

  const [isExpandedMarketedBy, setIsExpandedMarketedBy] = useState(false);
  const [isExpandedDevelopedBy, setIsExpandedDevelopedBy] = useState(false);

  const toggleMarketedBy = () => {
    setIsExpandedMarketedBy((prev) => !prev);
  };

  const toggleDevelopedBy = () => {
    setIsExpandedDevelopedBy((prev) => !prev);
  };

  const [navOffset, setNavOffset] = useState(0);
  const [hasReachedPayment, setHasReachedPayment] = useState(false);

  useEffect(() => {
    if (formRef.current) {
      setFormHeight(formRef.current.offsetHeight);
    }
  }, [formRef.current]);

  const getImageUrlForStage = (stageId) => {
    const selectedStage = stages.find((stage) => stage.id === stageId);
    if (selectedStage && selectedStage.images.length > 0) {
      return selectedStage.images[0]; // show first image for now
    }
    return "";
  };
  const handleImageClick = (stageId) => {
    const selectedStage = stages.find((stage) => stage.id === stageId);
    if (selectedStage) {
      setModalImages(selectedStage.images);
      setShowModal(true);
    }
  };

  const stages = [{ id: 1, label: "Dec 2024", images: [B1] }];

  const [activeStage, setActiveStage] = useState(stages[stages.length - 1].id);

  const overviewRef = useRef(null);
  const developmentRef = useRef(null);
  const locationRef = useRef(null);
  const navRef = useRef(null);

  const scrollPosition = window.scrollY || window.pageYOffset;
  const formOffset = formRef.current?.offsetTop || 0;
  const paymentBottom =
    paymentRef.current?.offsetTop + paymentRef.current?.offsetHeight || 0;

  // Scroll handler for the enquiry form
  const overviewTop = 300;

  useEffect(() => {
    const updatePositions = () => {
      if (paymentRef.current && formRef.current) {
        setPaymentTop(paymentRef.current.offsetTop);
        setFormHeight(formRef.current.offsetHeight);
      }
    };

    updatePositions();
    window.addEventListener("resize", updatePositions);
    return () => window.removeEventListener("resize", updatePositions);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY || window.pageYOffset;

      if (!formRef.current || !paymentRef.current || !overviewRef.current)
        return;

      const formHeight = formRef.current.offsetHeight;
      const formOffset = formRef.current.offsetTop;
      const paymentBottom =
        paymentRef.current.offsetTop + paymentRef.current.offsetHeight;
      const overviewTop = overviewRef.current.offsetTop;

      // If above form or overview section
      if (scrollPosition < overviewTop) {
        setIsSticky(false);
        setIsBottom(false);
        return;
      }

      // Sticky state
      if (scrollPosition > 50 && scrollPosition + formHeight < paymentBottom) {
        if (!isSticky) {
          const rect = formRef.current.getBoundingClientRect();
          setStickyLeft(rect.left);
        }
        setIsSticky(true);
        setIsBottom(false);
      }
      // Reached bottom of Payment section
      else if (scrollPosition + formHeight >= paymentBottom) {
        setIsSticky(false);
        setIsBottom(true);
      }
      // Default fallback
      else {
        setIsSticky(false);
        setIsBottom(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Initial check

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isSticky]);

  // Scroll handler for the navigation bar
  useEffect(() => {
    window.scrollTo(0, 0);
    if (navRef.current) {
      setNavOffset(navRef.current.offsetTop);
    }

    const handleNavScroll = () => {
      if (window.pageYOffset >= navOffset) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleNavScroll);
    return () => {
      window.removeEventListener("scroll", handleNavScroll);
    };
  }, [navOffset]);

  // Limit to 150 characters

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const handleNext = () => {
    const currentIndex = stages.findIndex((stage) => stage.id === activeStage);
    const nextIndex = (currentIndex + 1) % stages.length;
    setActiveStage(stages[nextIndex].id);
  };

  const handlePrev = () => {
    const currentIndex = stages.findIndex((stage) => stage.id === activeStage);
    const prevIndex = (currentIndex - 1 + stages.length) % stages.length;
    setActiveStage(stages[prevIndex].id);
  };

  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const settingss = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const handleScrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  const submit = () => {
    const fullName = document.getElementById("fullName");
    const phone = document.getElementById("phone");
    const email = document.getElementById("email");

    if (!fullName?.value?.trim()) {
      toast.error("Please enter your name");
      return;
    }
    if (!phone?.value?.trim()) {
      toast.error("Please enter your phone number");
      return;
    }

    const params = {
      fullName: fullName.value.trim(),
      phone: phone.value.trim(),
      email: email?.value?.trim() || "",
    };

    axios
      .post(`${api_url}contact/create`, params)
      .then((res) => {
        if (res.data.status === "ok") {
          toast.success("Your message was submitted successfully!");
          // Clear form fields
          fullName.value = "";
          phone.value = "";
          if (email) email.value = "";

          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          toast.error(res.data.message || "Error submitting your message");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("An unexpected error occurred. Please try again later.");
      });
  };
  return (
    <>
      <Helmet>
        <title>9K Suites Nathia Gali - Payment Plan</title>
        <meta
          name="description"
          content="
 Discover affordable apartments at 9K Suites Nathia Gali – stylish, luxurious living in the serene hills of Nathia Gali. Contact Us Now! heart of Murree. "
        />
      </Helmet>

      <div className="position-relative view_property">
        <ToastContainer />

        <div
          className=" position-fixed w-100"
          style={{ zIndex: "999999", marginTop: "-8em" }}
        >
          <TopNav />
          <BottomNav />
        </div>

        <div style={{ marginTop: "8em", zIndex: "0" }}>
          <div className="container mb-3">
            <div className="d-flex align-items-center justify-content-between flex-wrap ">
              <div className="d-flex align-items-center mt-2">
                <img
                  src={developerlogo} // or use the imported image
                  alt="Project Logo"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "contain",
                    marginRight: "1em",
                  }}
                />
                <div>
                  <h4
                    className="mb-0"
                    style={{ fontSize: "25px", color: "#4db749", zIndex: 10 }}
                  >
                    (9k Suites Nathia Gali)
                  </h4>
                  <small className="text-muted">Nathia Gali,Murree</small>
                </div>
              </div>
              <div>
                <h5 className="mb-0">
                  <small className="text-muted">
                    STARTING FROM <br />
                  </small>
                  <span style={{ fontSize: "22px" }}>PKR </span>

                  <strong
                    style={{ fontSize: "25px", color: "#4db749", zIndex: 10 }}
                  >
                    6,900,000 to 38,750,000
                  </strong>
                </h5>
              </div>
            </div>
          </div>

          <div className="container mt-3 mb-3">
            <div className="row">
              <div className="col-sm-8">
                <Slider {...settings}>
                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={B1}
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>

                  <div>
                    <img
                      loading="lazy"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      src={B2}
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </Slider>
              </div>
              <div className="col-sm-4">
                <img
                  className="imagedata"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  src={B1}
                  loading="lazy"
                  style={{ width: "100%", height: "auto", cursor: "pointer" }}
                />
                <img
                  className="imagedata"
                  id="overview"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  src={B2}
                  style={{
                    width: "100%",
                    height: "auto",
                    paddingTop: "0.89em",
                    cursor: "pointer",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container d-flex">
          <a href="#home-tab">
            <i
              className="bi bi-camera mx-2 icon-dark-bg"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
              onClick={() => document.getElementById("home-tab").click()}
              style={{ cursor: "pointer" }}
            ></i>
          </a>

          <a>
            <i
              className="bi bi-geo-alt mx-2"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
              onClick={() => document.getElementById("contact-tab").click()}
              style={{ cursor: "pointer" }}
            ></i>
          </a>
        </div>

        <div
          class="modal fade"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
          style={{ zIndex: "100000000000" }}
        >
          <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">
                  9k Suites Nathiagali
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#home"
                      type="button"
                      role="tab"
                      aria-controls="home"
                      aria-selected="true"
                    >
                      Images
                    </button>
                  </li>

                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="contact-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#contact"
                      type="button"
                      role="tab"
                      aria-controls="contact"
                      aria-selected="false"
                    >
                      Map
                    </button>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade show active"
                    id="home"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    <div className="slider-container p-5">
                      <Slider {...settingss}>
                        <div>
                          <img
                            loading="lazy"
                            src={B2}
                            alt="Avenue18-p5"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>

                        <div>
                          <img
                            loading="lazy"
                            src={B1}
                            alt="Avenue18-p4"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                      </Slider>
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  ></div>

                  <div
                    class="tab-pane fade"
                    id="contact"
                    role="tabpanel"
                    aria-labelledby="contact-tab"
                  >
                    <div className="p-5">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d848360.0750343994!2d72.35523694221354!3d33.840520708151516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e0!4m5!1s0x38df948974419acb%3A0x984357e1632d30f!2sRawalpindi!3m2!1d33.5651107!2d73.0169135!4m5!1s0x38dfd4b203243f2b%3A0xe2a84441ca2e0678!2sNathia%20Gali%20Abbottabad%2C%20Khyber%20Pakhtunkhwa!3m2!1d34.0729404!2d73.3811849!5e0!3m2!1sen!2s!4v1728371403404!5m2!1sen!2s"
                        width="100%"
                        height="400px"
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Div  */}

        <div className="fixed-bar">
          <button type="button" class="btn btn-primary">
            Contact Us
          </button>

          <a href="+923311111049">
            <button className="col-sm-4 btn fixed-button">
              <i class="bi bi-telephone"></i> Call
            </button>
          </a>
          <a href="http://wa.me/+923311111045">
            <button className="col-sm-4 btn fixed-button">
              <i class="bi bi-whatsapp"></i>
            </button>
          </a>
        </div>

        {/* Tabs bars  */}
        <div
          ref={navRef}
          className={`mid-nav ${isFixed ? "fixed" : ""}`}
          id="midNav"
          style={{ zIndex: "10000000" }}
        >
          <div className="nav-buttons-container py-3">
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("overview")}
            >
              Overview
            </button>

            <button
              className="nav-button"
              onClick={() => handleScrollToSection("development")}
            >
              Development Updates
            </button>
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("location")}
            >
              Location
            </button>
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("payment")}
            >
              Payment Plans Floor Plans
            </button>
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("FAQ's")}
            >
              FAQ's
            </button>
            <button
              className="nav-button"
              onClick={() => handleScrollToSection("marketed")}
            >
              Developed By
            </button>
          </div>
        </div>
        <div className="container mt-3">
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-12">
                  <div className="read-more-container" ref={overviewRef}>
                    <h2
                      style={{
                        color: "#4db749",
                        fontWeight: "bold",
                        fontSize: "22px",
                      }}
                    >
                      Overview
                    </h2>

                    {/* <div>
                      <p style={{ paddingTop: "1em" }}>
                        {isExpandedd ? fullText : shortenedText}
                      </p>
                      <button
                        onClick={() => setIsExpandedd(!isExpandedd)}
                        style={{
                          color: "#4db749",
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",
                          fontSize: "13px",
                        }}
                      >
                        {isExpandedd ? "Show Less" : "Show More"}
                      </button>
                    </div> */}

                    <li className="d-flex justify-content-between align-items-center p-3">
                      {/* Left Section: Icon + Text */}
                      <div className="d-flex align-items-center">
                        <i
                          className="bi bi-geo-alt me-2"
                          style={{
                            fontSize: "20px",
                            color: "#4db749",
                            zIndex: 10,
                          }}
                        ></i>
                        <div className="d-flex flex-column">
                          <span style={{ fontSize: "14px" }}>Location</span>
                          <div className="fw-bold">Nathia Gali</div>
                        </div>
                      </div>

                      {/* Right Section: Icon + Text */}
                      <div className="d-flex align-items-center">
                        <i
                          className="bi bi-person me-2"
                          style={{
                            fontSize: "20px",
                            color: "#4db749",
                            zIndex: 10,
                          }}
                        ></i>
                        <div className="d-flex flex-column">
                          <span style={{ fontSize: "14px" }}>Developer</span>
                          <div className="fw-bold">9k Suites</div>
                        </div>
                      </div>
                    </li>

                    <style>
                      {`
  .mid-nav {
    z-index: 100 !important;
  }
  .fixed-bar {
    z-index: 100 !important;
  }
  .position-fixed {
    z-index: 100 !important;
  }
  
  .accordion-item {
  border: 1px solid #dee2e6 !important;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
  overflow: hidden; /* Keeps border-radius on child elements */
}

/* Header styling */
.accordion-button {
  border-bottom: 1px solid #dee2e6 !important;
  background-color: white;
}

/* Active header */
.accordion-button:not(.collapsed) {
  
  background-color: rgb(218, 237, 215) !important;
}

/* Remove double border when collapsed */
.accordion-button.collapsed {
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

/* Remove the border from accordion-body */
.accordion-body {
background-color: rgb(218, 237, 215) !important;
  border: none !important;
}
  
  `}
                    </style>

                    <div className="accordion mt-5" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                          <button
                            className="accordion-button collapsed d-flex align-items-center w-100"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                            style={{
                              backgroundColor: "",
                              paddingTop: "40px",
                              paddingBottom: "40px",
                              border: "none",
                            }}
                          >
                            {/* Left Section: Icon + Text */}
                            <div className="d-flex align-items-center">
                              <i
                                className="bi bi-shop me-2"
                                style={{
                                  fontSize: "20px",
                                  color: "#4db749",
                                  zIndex: 10,
                                }}
                              ></i>
                              <span className="fw-bold">Studio</span>
                            </div>

                            {/* Spacer to push content to the right */}
                            <div className="flex-grow-1"></div>

                            {/* Right Section: Price + Dropdown Icon */}
                            <div className="d-flex align-items-center">
                              <span
                                className="text-muted me-1"
                                style={{ fontSize: "12px" }}
                              >
                                PKR
                              </span>
                              <span className="fw-bold me-1">
                                23 Thousand to
                                <span className="mobile-break">
                                  <br />
                                </span>{" "}
                                31 Thousand
                              </span>
                            </div>
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <li
                              className=" d-flex justify-content-between align-items-center p-3 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div
                                className="d-flex flex-column"
                                style={{ backgroundColor: "white" }}
                              >
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Lower Ground Studio
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size: 300 To 375Per sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                23 Thousand
                              </div>
                            </li>

                            <li
                              className="d-flex justify-content-between align-items-center p-3 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  First Floor Studio
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size: 375 Per sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                25 Thousand
                              </div>
                            </li>
                            <li
                              className="d-flex justify-content-between align-items-center p-3 mt-4 mb-4  shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  2nd Floor Studio
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size:375 sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                26 Thousand
                              </div>
                            </li>
                            <li
                              className="d-flex justify-content-between align-items-center p-3   shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  3rd Floor Studio
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size:375 sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>
                                28 Thousand
                              </div>
                            </li>
                          </div>
                        </div>
                      </div>

                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button  d-flex align-items-center w-100 collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-controls="collapseTwo"
                            style={{
                              paddingTop: "40px",
                              paddingBottom: "40px",

                              border: "none",
                            }}
                          >
                            {/* Left Section: Icon + Text */}
                            <div className="d-flex align-items-center">
                              <i
                                className="bi bi-building me-2"
                                style={{
                                  fontSize: "20px",
                                  color: "#4db749",
                                  zIndex: 10,
                                }}
                              ></i>
                              <span className="fw-bold">1 Bed</span>
                            </div>

                            {/* Spacer to push content to the right */}
                            <div className="flex-grow-1"></div>

                            {/* Right Section: Price + Arrow */}
                            <div className="d-flex align-items-center">
                              <span
                                className="text-muted me-1"
                                style={{ fontSize: "12px" }}
                              >
                                PKR
                              </span>
                              <span className="fw-bold me-3">
                                23 Thousand To 28 Thousand
                              </span>
                            </div>
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          className="collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <li
                              className=" d-flex justify-content-between align-items-center p-3 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Ground Floor 1 Bed
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size: 500Per sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>{" "}
                                23 Thousand
                              </div>
                            </li>

                            <li
                              className=" d-flex justify-content-between align-items-center p-3 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  1st Floor 1 Bed
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size: 500 - 550Per sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>{" "}
                                25 Thousand
                              </div>
                            </li>

                            <li
                              className=" d-flex justify-content-between align-items-center p-3 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  2nd Floor 1 Bed
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size: 500 - 550 Per sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>{" "}
                                26 Thousand
                              </div>
                            </li>
                            <li
                              className=" d-flex justify-content-between align-items-center p-3 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  3rd Floor 1 Bed
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size: 500 - 550Per sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>{" "}
                                28 Thousand
                              </div>
                            </li>
                          </div>
                        </div>
                      </div>

                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button  d-flex align-items-center w-100 collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTen"
                            aria-controls="collapseTen"
                            style={{
                              paddingTop: "40px",
                              paddingBottom: "40px",

                              border: "none",
                            }}
                          >
                            {/* Left Section: Icon + Text */}
                            <div className="d-flex align-items-center">
                              <i
                                className="bi bi-building me-2"
                                style={{
                                  fontSize: "20px",
                                  color: "#4db749",
                                  zIndex: 10,
                                }}
                              ></i>
                              <span className="fw-bold">Pent House</span>
                            </div>

                            {/* Spacer to push content to the right */}
                            <div className="flex-grow-1"></div>

                            {/* Right Section: Price + Arrow */}
                            <div className="d-flex align-items-center">
                              <span
                                className="text-muted me-1"
                                style={{ fontSize: "12px" }}
                              >
                                PKR
                              </span>
                              <span className="fw-bold me-3">31 Thousand</span>
                            </div>
                          </button>
                        </h2>
                        <div
                          id="collapseTen"
                          className="collapse"
                          aria-labelledby="headingTen"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body">
                            <li
                              className=" d-flex justify-content-between align-items-center p-3 shadow-sm rounded"
                              style={{ backgroundColor: "white" }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className="fw-bold"
                                  style={{ color: "#4db749" }}
                                >
                                  Pent House
                                </div>
                                <div className="d-flex align-items-center text-muted">
                                  <span>Area Size: 1250 Per sq.ft</span>
                                </div>
                              </div>
                              <div className="text-end fw-bold  ">
                                <span
                                  className="text-muted me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  PKR
                                </span>{" "}
                                31 Thousand
                              </div>
                            </li>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div
                ref={formRef}
                className={`sticky-form d-none d-lg-block ${
                  isSticky ? "fixed" : ""
                } ${isBottom ? "bottom" : ""}`}
                style={{
                  backgroundImage: `url(${lightgreen})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  padding: "1.2em",
                  paddingTop: "0.8em",
                  paddingBottom: "1.5em",
                  borderRadius: "8px",
                  width: "100%",
                  maxWidth: "22em",
                  boxSizing: "border-box",
                  position: isSticky
                    ? "fixed"
                    : isBottom
                    ? "absolute"
                    : "relative",

                  // Lock the top and left when sticky
                  top: isSticky
                    ? "10em"
                    : isBottom
                    ? `${paymentBottom - formHeight}px`
                    : "auto",
                  left: isSticky ? stickyLeft : "auto", // <-- Add this line

                  transform: "none",
                  willChange: "transform",
                }}
              >
                <h4
                  className="text-center text-black mb-2"
                  style={{ fontSize: "16px", fontWeight: "600" }}
                >
                  MAKE AN ENQUIRY
                </h4>
                <div className="text-center mb-2">
                  <a
                    href="tel:03311111049"
                    className="text-decoration-none d-block"
                  >
                    <button
                      className="btn btn-success w-100 py-1"
                      style={{
                        backgroundColor: "#00B53F",
                        border: "none",
                        height: "32px",
                      }}
                    >
                      <BsTelephone className="me-2" />
                      Call Now
                    </button>
                  </a>
                  <div
                    className="text-center my-1"
                    style={{ fontSize: "13px", color: "#666" }}
                  >
                    or
                  </div>
                </div>
                <div>
                  <div className="mb-2">
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "13px", color: "#333" }}
                    >
                      Your Name *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fullName"
                      placeholder="How should we address you?"
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid #ddd",
                        height: "32px",
                        fontSize: "13px",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                  <div className="mb-2">
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "13px", color: "#333" }}
                    >
                      Phone Number *
                    </label>
                    <div className="input-group">
                      <span
                        className="input-group-text"
                        style={{
                          backgroundColor: "#fff",
                          fontSize: "13px",
                          border: "1px solid #ddd",
                          borderRight: "none",
                          width: "75px",
                          height: "35px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src="https://flagcdn.com/w20/pk.png"
                          alt="PK"
                          style={{ width: "18px" }}
                          className="me-1"
                        />
                        +92
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        placeholder="Your phone number"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          borderLeft: "none",
                          height: "35px",
                          fontSize: "13px",
                          borderRadius: "0 4px 4px 0",
                          flex: "1",
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-2">
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "13px", color: "#333" }}
                    >
                      Email Address (Optional)
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Your best email address?"
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid #ddd",
                        height: "32px",
                        fontSize: "13px",
                        borderRadius: "4px",
                      }}
                    />
                  </div>
                  <button
                    className="btn btn-success w-100 py-1 mt-2"
                    onClick={submit}
                    style={{
                      backgroundColor: "#00B53F",
                      border: "none",
                      height: "35px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      fontWeight: "500",
                    }}
                  >
                    <BsSend className="me-2" />
                    Request Call
                  </button>
                  <div
                    className="text-center text-muted mt-2"
                    style={{ fontSize: "11px" }}
                  >
                    By submitting this form, you agree to{" "}
                    <a href="#" className="text-primary text-decoration-none">
                      Terms of Use
                    </a>
                    .
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Form Button */}
            <div
              className="d-lg-none fixed-bottom bg-white p-3"
              style={{ boxShadow: "0 -2px 10px rgba(0,0,0,0.1)" }}
            >
              <button
                className="btn btn-success w-100"
                style={{ backgroundColor: "#00B53F" }}
                onClick={() => setShowFormModal(true)}
              >
                Make an Enquiry
              </button>
            </div>

            {/* Mobile Form Modal */}
            <Modal
              show={showFormModal}
              onHide={() => setShowFormModal(false)}
              centered
              style={{ zIndex: "9999999" }}
              dialogClassName="modal-on-top"
              contentClassName="position-relative"
            >
              <Modal.Header
                closeButton
                style={{
                  backgroundImage: `url(${lightgreen})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  border: "none",
                  paddingTop: "1.2em",
                  paddingBottom: "0",
                }}
              >
                <Modal.Title
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  MAKE AN ENQUIRY
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                style={{
                  backgroundImage: `url(${lightgreen})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  padding: "1.2em",
                }}
              >
                <div>
                  <div className="text-center mb-2">
                    <a
                      href="tel:03311111049"
                      className="text-decoration-none d-block"
                    >
                      <button
                        className="btn btn-success w-100 py-1"
                        style={{
                          backgroundColor: "#00B53F",
                          border: "none",
                          height: "32px",
                        }}
                      >
                        <BsTelephone className="me-2" />
                        Call Now
                      </button>
                    </a>
                    <div
                      className="text-center my-1"
                      style={{ fontSize: "13px", color: "#666" }}
                    >
                      or
                    </div>
                  </div>
                  <div>
                    <div className="mb-2">
                      <label
                        className="form-label mb-1"
                        style={{ fontSize: "13px", color: "#333" }}
                      >
                        Your Name *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="fullName"
                        placeholder="How should we address you?"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          height: "32px",
                          fontSize: "13px",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                    <div className="mb-2">
                      <label
                        className="form-label mb-1"
                        style={{ fontSize: "13px", color: "#333" }}
                      >
                        Phone Number *
                      </label>
                      <div className="input-group">
                        <span
                          className="input-group-text"
                          style={{
                            backgroundColor: "#fff",
                            fontSize: "13px",
                            border: "1px solid #ddd",
                            borderRight: "none",
                            width: "75px",
                            height: "32px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src="https://flagcdn.com/w20/pk.png"
                            alt="PK"
                            style={{ width: "18px" }}
                            className="me-1"
                          />
                          +92
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          id="phone"
                          placeholder="Your phone number"
                          style={{
                            backgroundColor: "#fff",
                            border: "1px solid #ddd",
                            borderLeft: "none",
                            height: "32px",
                            fontSize: "13px",
                            borderRadius: "0 4px 4px 0",
                            flex: "1",
                          }}
                        />
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        className="form-label mb-1"
                        style={{ fontSize: "13px", color: "#333" }}
                      >
                        Email Address (Optional)
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Your best email address?"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          height: "32px",
                          fontSize: "13px",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                    <button
                      className="btn btn-success w-100 py-1 mt-2"
                      onClick={submit}
                      style={{
                        backgroundColor: "#00B53F",
                        border: "none",
                        height: "35px",
                        fontSize: "14px",
                        borderRadius: "4px",
                        fontWeight: "500",
                      }}
                    >
                      <BsSend className="me-2" />
                      Request Call
                    </button>
                    <div
                      className="text-center text-muted mt-2"
                      style={{ fontSize: "11px" }}
                    >
                      By submitting this form, you agree to{" "}
                      <a href="#" className="text-primary text-decoration-none">
                        Terms of Use
                      </a>
                      .
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-12">
                  <div className="read-more-container">
                    <h2
                      style={{
                        color: "#4db749",
                        fontWeight: "bold",
                        fontSize: "22px",
                      }}
                    >
                      9k Suites Nathia Gali
                    </h2>

                    <h1
                      style={{
                        color: "#4db749",
                      }}
                    >
                      Welcome to 9K Suites Nathia Gali - Luxurious and Modern
                      Accommodations
                    </h1>
                    <br />

                    <p>
                      9K Suite Nathia Gali is a top-class hospitality venture by
                      Makkaan Developments, giving visitors luxurious facilities
                      in a beautiful area of Nathia Gali. Surrounded by the
                      peaceful hills of Murree, 9K Suite gives tourists the
                      chance to experience comfort and nature together.
                      <br />
                      <br />
                      <h4 style={{ color: "#4db749" }} id="development">
                        Available Accommodation at 9K Suite Nathia Gali
                      </h4>
                      <br />
                      <p>
                        We can provide visitors and investors with these types
                        of suites and rooms:
                      </p>
                      <ol class="custom-list">
                        <li>
                          {" "}
                          <b>Luxury Suites:</b>You’ll find these suites both
                          spacious and beautifully designed, with terrific views
                          and all the modern amenities.
                        </li>
                        <li>
                          {" "}
                          <b>Family Rooms:</b>These rooms are comfortable
                          especially designed for families with a lot of space
                          and soothing architecture.
                        </li>
                        <li>
                          {" "}
                          <b>Studio Apartments:</b>If you’re alone or a couple,
                          studio apartments are an ideal match for comfort and
                          privacy.
                        </li>
                      </ol>
                    </p>
                    {isExpanded && (
                      <p>
                        <h4 style={{ color: "#4db749" }}>
                          Why Choose 9K Suite Nathia Gali?
                        </h4>
                        Be sure to learn the main reasons 9K Suite fits your
                        needs before you decide to book or invest
                        <ol>
                          <h5 style={{ color: "#4db749" }}>
                            <li>
                              <b>Prime Location</b>
                            </li>
                            <br />
                          </h5>
                          <p>
                            Nathia Gali, one of Pakistan’s most favorite hill
                            spots, is where the 9K Suite is found. Anyone
                            staying here gets easy access to hiking trails,
                            local stores and some of the best views around.
                          </p>
                          <h5 style={{ color: "#4db749" }}>
                            <li>
                              <b>Modern Architecture with Mountain Charm</b>
                            </li>
                          </h5>
                          <br />
                          <p>
                            The look of the 9K Suite fits in perfectly with its
                            surroundings, mixing today’s luxury with
                            mountain-style details. Large windows, wooden
                            finishes and wide balconies help make the furniture
                            feel both comfortable and cozy.
                          </p>

                          <h5 style={{ color: "#4db749" }}>
                            <li>
                              <b>Stunning Natural Views</b>
                            </li>
                            <br />
                          </h5>
                          <p>
                            Every room at the lodge lets you view the
                            surrounding forests and hills, so guests can relax
                            and enjoy the beautiful scenery.
                          </p>

                          <h5 style={{ color: "#4db749" }}>
                            <li>
                              <b>Comprehensive Amenities</b>
                            </li>
                            <br />
                          </h5>
                          <p>
                            All guest needs are catered by 9K Suite Nathia Gali.
                          </p>

                          <ol class="custom-list">
                            <li>
                              There is staff available to help you day and
                              night, as well as 24-hour security.
                            </li>
                            <li>
                              Wi-Fi that works very fast and a smart television
                            </li>
                            <li>
                              Both nationally and worldwide cuisine options that
                              deliver right inside the hotel
                            </li>
                            <li>Parking and easy access routes</li>
                            <li>
                              Heating systems for keeping you warm during low
                              temperatures
                            </li>
                          </ol>
                        </ol>
                        <h4 style={{ color: "#4db749" }}>
                          Explore 9K Suite: Room-by-Room Overview
                        </h4>
                        <h5 style={{ color: "#4db749" }}>
                          Luxury Suites – Crafted for Along-Stay Relaxation
                        </h5>
                        <ol class="custom-list">
                          <li>
                            Large suites that include king-sized beds, balconies
                            and newly updated bathrooms.
                          </li>
                          <li>
                            <b>Features:</b>A well-planned 6-foot-wide corridor
                            for smooth customer flow and convenient entrances.
                          </li>
                          <li>
                            Amenities: Wide windows for ample sun, comfortable,
                            stylish furniture and an area for sitting..
                          </li>
                          <li>
                            Best For: Anyone who wants a luxury place to stay
                            with amazing scenery.
                          </li>
                        </ol>
                        <h5 style={{ color: "#4db749" }}>
                          Family Rooms — Cozy and Spacious
                        </h5>
                        <ol class="custom-list">
                          <li>
                            The rooms are created for families and come with
                            extra beds, along with family-friendly amenities
                          </li>
                          <li>
                            Features: A private living area, warm rooms and
                            get-it-to-you room service.
                          </li>
                          <li>
                            Ideal for: Families on a holiday or a short break in
                            Nathia Gali are who would benefit most..
                          </li>
                        </ol>
                        <h5 style={{ color: "#4db749" }}>
                          Studio Apartments – Compact Comfort
                        </h5>
                        <ol class="custom-list">
                          <li>
                            Studio spaces that let you easily live and sleep
                            within the same room.
                          </li>
                          <li>
                            Features: You will find a kitchenette, a smart TV
                            and a work desk in your room.
                          </li>

                          <li>
                            Ideal For: It’s great for guests traveling either
                            solo or with a partner.
                          </li>
                        </ol>
                        <h3>
                          Don’t Miss Out – Book Your Stay at 9K Suite Nathia
                          Gali Today!
                        </h3>
                        <p>
                          The mix of nature’s charm and modern amenities at 9K
                          Suite Nathia Gali brings many people to this place.
                          Book your rooms with us right away by calling or going
                          to{" "}
                          <a href="https://www.makkaan.com/" target="_blank">
                            {" "}
                            Makkaan.com
                          </a>{" "}
                          . Take advantage of peaceful Nathia Gali by staying in
                          the 9K Suite!
                        </p>
                        <div></div>
                      </p>
                    )}
                    <a
                      onClick={toggleReadMore}
                      style={{ color: "green", cursor: "pointer" }}
                    >
                      {isExpanded ? "Read Less" : "Read More"}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-5" ref={developmentRef}>
          <div className="row">
            <div className="col-lg-8">
              <div className="read-more-container">
                <h2
                  style={{
                    color: "#4db749",
                    fontWeight: "bold",
                    fontSize: "22px",
                  }}
                >
                  Development Updates for 9k Suites Nathiagali
                </h2>

                <div className="row">
                  {/* Timeline first */}
                  <div className="col-12">
                    <div className="timeline">
                      {stages.map((stage, index) => (
                        <div key={stage.id} className="timeline-stage">
                          <div
                            className={`circle ${
                              activeStage === stage.id ? "active" : ""
                            }`}
                            onClick={() => setActiveStage(stage.id)}
                          >
                            <>
                              {stage.label.split(" ")[0]} <br />
                              {stage.label.split(" ")[1]}
                            </>
                          </div>
                          {index < stages.length - 1 && (
                            <div className="line"></div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Images second */}
                  <div className="col-12 mt-4">
                    <div className="timeline-images">
                      {stages
                        .filter((stage) => stage.id === activeStage)
                        .map((stage) => (
                          <div key={stage.id}>
                            {stage.images.map((image, index) => (
                              <img
                                key={index}
                                src={image}
                                alt={`${stage.label}-preview`}
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  marginBottom: "20px",
                                  cursor: "pointer",
                                  objectFit: "cover",
                                  borderRadius: "10px",
                                }}
                                onClick={() => handleImageClick(stage.id)}
                              />
                            ))}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="location"></div>
        </div>

        <div className="container mt-5" ref={locationRef}>
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-12">
                  <div className="read-more-container">
                    <h2
                      style={{
                        color: "#4db749",
                        fontWeight: "bold",
                        fontSize: "22px",
                      }}
                    >
                      Location
                    </h2>

                    <div className="row mt-3">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d848360.0750343994!2d72.35523694221354!3d33.840520708151516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e0!4m5!1s0x38df948974419acb%3A0x984357e1632d30f!2sRawalpindi!3m2!1d33.5651107!2d73.0169135!4m5!1s0x38dfd4b203243f2b%3A0xe2a84441ca2e0678!2sNathia%20Gali%20Abbottabad%2C%20Khyber%20Pakhtunkhwa!3m2!1d34.0729404!2d73.3811849!5e0!3m2!1sen!2s!4v1728371403404!5m2!1sen!2s"
                        width="600"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Google Map"
                      ></iframe>
                      <div id="payment"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-5" ref={paymentRef}>
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-12">
                  <div className="read-more-container">
                    <h2
                      style={{
                        color: "#4db749",
                        fontWeight: "bold",
                        fontSize: "22px",
                      }}
                    >
                      Payment Floor plans For 9k Suites Nathiagali
                    </h2>

                    <div class="row">
                      <div class="col-sm-12 col-md-6 col-lg-4">
                        <div className="card" style={{ width: "100%" }}>
                          <div className="row">
                            <a
                              href={paymentplan}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                loading="lazy"
                                src={karat1}
                                className="card-img-top"
                                alt="Avenue18-paymentplan"
                                style={{ padding: "10px", borderRadius: "5px" }}
                              />
                            </a>
                            <div className="card-body">
                              <p className="card-text">
                                9k Suites Nathiagali Payment Plan
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-4">
                        <div className="card" style={{ width: "100%" }}>
                          <a
                            href={floorplan}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              loading="lazy"
                              src={karat2}
                              className="card-img-top"
                              alt="Avenue18-floorplan"
                              style={{ padding: "10px", borderRadius: "5px" }}
                            />
                          </a>
                          <div className="card-body" id="FAQ's">
                            <p className="card-text">
                              9k Suites nathiagali Floor plans
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-3" ref={paymentRef}>
          <div className="row">
            <div className="col-lg-8">
              <div className="col-12">
                <div className="read-more-container">
                  <h2
                    style={{
                      color: "#4db749",
                      fontWeight: "bold",
                      fontSize: "22px",
                    }}
                  >
                    FAQ's
                  </h2>

                  <div class="accordion mt-3" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          Q1: What different rooms can I choose from at 9K Suite
                          Nathia Gali?
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: We give our guests the option of staying in luxury
                          suites, family rooms or studio apartments.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefour"
                          aria-expanded="false"
                          aria-controls="collapsefour"
                        >
                          Q2: Is the 9K Suite placed in Nathia Gali city center?
                        </button>
                      </h2>
                      <div
                        id="collapsefour"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: You will find a 9K Suite situated just close to
                          both the main market and the major tourist attractions
                          in Nathia Gali.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          Q3: What items and services are included in the 9K
                          Suite?
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: You can enjoy security all day, every day and
                          access Wi-Fi, meals on-site, heating, parking and
                          more.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header" id="marketed">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSix"
                          aria-expanded="false"
                          aria-controls="collapseSix"
                        >
                          Q4: Can 9K Suite be used on a family vacation?
                        </button>
                      </h2>
                      <div
                        id="collapseSix"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: Absolutely! Having family-sized rooms and special
                          services for kids, this place is perfect for families.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSeven"
                          aria-expanded="false"
                          aria-controls="collapseSeven"
                        >
                          Q5: How do I reserve a room or suite at 9K Suite
                          Nathia Gali?
                        </button>
                      </h2>
                      <div
                        id="collapseSeven"
                        className="accordion-collapse collapse"
                      >
                        <div className="accordion-body lh-base">
                          A: We’re available on Makkaan.com for reservations or
                          you may get in touch with our team for booking
                          support.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mb-3 mt-3">
          <div className="row">
            <div className="col-md-6 mb-3">
              <div
                className="card"
                style={{
                  minHeight: isExpandedMarketedBy ? "auto" : "250px",
                  transition: "min-height 0.3s ease",
                }}
              >
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      loading="lazy"
                      src={makkaanLogo}
                      className="img-fluid rounded-start"
                      alt="Makkaan-logo"
                      style={{ padding: "15px", marginTop: "25px" }}
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <h3 className="card-title">Marketed By</h3>
                      <h5 className="card-title">Makkaan.com</h5>
                      <p>
                        Makkaan.com is a trustworthy and responsible platform
                        that aims to provide you with all the Residential,
                        Commercial, and Investment details under the same roof.
                        The only podium that offers reliable services to
                        investors, dealers, societies,
                      </p>
                      {isExpandedMarketedBy && (
                        <p>
                          and end-users of the real estate world throughout the
                          country. We use an all-inclusive marketing strategy
                          that covers all aspects of projects and helps
                          investors at every stage of the process with complete
                          transparency.
                        </p>
                      )}
                      <a
                        onClick={toggleMarketedBy}
                        style={{ color: "green", cursor: "pointer" }}
                      >
                        {isExpandedMarketedBy ? "Read Less" : "Read More"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-3">
              <div
                className="card"
                style={{
                  minHeight: isExpandedDevelopedBy ? "auto" : "250px",
                  transition: "min-height 0.3s ease",
                }}
              >
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      loading="lazy"
                      src={developerlogo}
                      className="img-fluid rounded-start"
                      alt="Avenue18-logo"
                      style={{ padding: "15px", marginTop: "25px" }}
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <h3 className="card-title">Developed By</h3>
                      <h5 className="card-title">9k Suites</h5>
                      <p>
                        Mr. Muqtadir Qazi is the developer of 9k Suites Nathia
                        Gali. With several years of experience in Real Estate,
                        he is a prominent name for 9k suites in Nathia Gali.
                      </p>
                      {isExpandedDevelopedBy && (
                        <p>
                          After the delivery of the successful project in Ayubia
                          - 9K Suites Ayubia- he now aims to provide all the
                          basic and modern features and amenities in this
                          project in Nathia Gali. So, this is one of the
                          specific projects that gives you to earn from your
                          residence.
                        </p>
                      )}
                      <a
                        onClick={toggleDevelopedBy}
                        style={{ color: "green", cursor: "pointer" }}
                      >
                        {isExpandedDevelopedBy ? "Read Less" : "Read More"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default Nineknathia;
